import type { SVGProps } from 'react';

const SvgCricleQaBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinejoin='round'
    />
    <path
      d='M11.1725 14.1985C11.0712 14.1985 11.0149 14.1498 11.0149 14.028L10.9586 11.6772C10.9586 11.5798 11.0262 11.5067 11.1162 11.5067H11.5552C12.771 11.5067 13.2889 10.8855 13.2889 10.0329C13.2889 9.24117 12.8161 8.74178 12.0055 8.74178C11.3301 8.74178 10.8798 9.13155 10.6096 9.7771C10.5646 9.87454 10.4858 9.91108 10.407 9.88672L9.12366 9.5335C9.02235 9.50914 8.97732 9.42387 9.01109 9.32643C9.4839 7.8648 10.6209 7 12.1294 7C13.818 7 15 8.12059 15 9.86236C15 11.3605 14.1332 12.676 12.5346 12.9562L12.5121 14.028C12.5121 14.1498 12.4446 14.1985 12.3545 14.1985H11.1725ZM10.7785 15.9769C10.7785 15.38 11.2063 14.9781 11.7579 14.9781C12.2982 14.9781 12.726 15.38 12.726 15.9769C12.726 16.5859 12.2982 17 11.7579 17C11.2063 17 10.7785 16.5859 10.7785 15.9769Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgCricleQaBd;
